import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { SimpleNoErrorComponent } from '../../utils/apollo';
import CollegeEventFilterMatches from './filterMatches';
import './styles.css';

const query = gql`
  query collegeEventFilterMatches($filter: queryCollegeEventFilterInput!) {
    viewer {
      id
      eventMatchCountByFilter (filter: $filter)
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ params: { filter = {} } }) => ({
    variables: {
      filter,
    },
  }),
});

export default SimpleNoErrorComponent(graphqlData)(CollegeEventFilterMatches);
